import { memo } from 'react';
import { InfoTooltip } from 'components/v3';
import SchoolIcon from '@mui/icons-material/School';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from '../message.scss';

const TeachButton = ({ setDisplayVqlGroundTruthModal }) => {
  const { t } = useTranslation();
  return (
    <InfoTooltip text={t('save-new-vql-ground-truth.title')}>
      <div onClick={() => setDisplayVqlGroundTruthModal(true)} className={styles.iconButtonContainer}>
        <SchoolIcon className={clsx(styles.iconButtonIcon)} />
        <span className={styles.iconButtonLabel}>{t('teach')}</span>
      </div>
    </InfoTooltip>
  );
};

export default memo(TeachButton);
